// extracted by mini-css-extract-plugin
module.exports = {"color-storm-grey":"#6D7288","colorStormGrey":"#6D7288","from":"_2MBcX _1D3zw _1Zmlx"};